import { combineReducers } from "redux";

import appLoaderReduer from "./app-loader-reducer";
import authenReducer from "./authen-reducer";
import bannerPreviewReducer from "./banner-reducer";
import serviceLinkPreviewReducer from "./service-link-reducer";
import footerLinkPreviewReducer from "./footer-link-reducer";
import highlightBoxPreviewReducer from "./highlight-box-reducer";
import notificationPreviewReducer from "./notification-reducer";
import mainContentPreviewReducer from "./main-content-reducer";
import templateContentPreviewReducer from "./template-content-reducer";
import menuPreviewReducer from "./menu-reducer";
import chatReducer from "./chat-reducer";
import masterReducer from "./master-reducer";

// const rootReducer = (state, action) => {
//     if (authenType.SIGN_OUT_SUCCESS===action.type) {
//         state = undefined;
//     }
//     return appReducer(state, action)
// };

const appReducer = combineReducers({
  appLoaderReduer,
  authenReducer,
  bannerPreviewReducer,
  serviceLinkPreviewReducer,
  footerLinkPreviewReducer,
  highlightBoxPreviewReducer,
  notificationPreviewReducer,
  mainContentPreviewReducer,
  templateContentPreviewReducer,
  menuPreviewReducer,
  chatReducer,
  masterReducer,
});

export default appReducer;
